import React, { Component } from "react";
import RingTypeList from "../RingTypeList";
import ButtonEdit from "../Button/ButtonEdit";
import ListMenu from "./ListMenu";

export default class Menu extends Component {
  render() {
    let {isShowPopupSp} = this.props;

    return (
      <div className="container">
        <div className={`menu ${isShowPopupSp ? 'is_show' : ''}`}>
          <div className="menu-wrap-upt">
            <div className="toolbar">
              <button className="button disabled" disabled label="拡大" type="button">
                <svg className="icon-upt">
                  <use xlinkHref={`#icon-zoom-in`} />
                </svg>
                <span className="label">拡大</span>
              </button>
                  <button className="button disabled" disabled label="縮小" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-zoom-out`} />
                    </svg>
                    <span className="label">縮小</span>
                  </button>
                  <button className="button disabled" disabled label="戻る" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-undo`} />
                    </svg>
                    <span className="label">戻る</span>
                  </button>
                  <button className="button disabled" disabled label="進む" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-redo`} />
                    </svg>
                    <span className="label">進む</span>
                  </button>
                  <button className="button disabled" disabled label="ガイド" type="button">
                    <img className="image" src="https://d7dytyhutq7ls.cloudfront.net/static/v1/image/18KuDSfsFT72q2TJ7KqrK2.svg" alt=""/>
                    <span className="label">ガイド</span>
                  </button>
                  <div className="separator"></div>
                  <button className="button disabled" disabled label="画像" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-image`} />
                    </svg>
                    <span className="label">画像</span>
                  </button>
                  <button className="button disabled" disabled label="テキスト" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-text`} />
                    </svg>
                    <span className="label">テキスト</span>
                  </button>
                  <button className="button disabled" disabled label="シェイプ" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-figures`} />
                    </svg>
                    <span className="label">シェイプ</span>
                  </button>
                  <button className="button disabled" disabled label="スタンプ" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-sticker`} />
                    </svg>
                    <span className="label">スタンプ</span>
                  </button>
                  <button className="button disabled" disabled label="筆" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-brush`} />
                    </svg>
                    <span className="label">筆</span>
                  </button>
                  <button className="button disabled" disabled label="レイヤー" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-layers`} />
                    </svg>
                    <span className="label">レイヤー</span>
                  </button>
                  <button className="button disabled" disabled label="全削除" type="button">
                    <svg className="icon-upt">
                      <use xlinkHref={`#icon-delete`} />
                    </svg>
                    <span className="label">全削除</span>
                  </button>
            </div>
          </div>
          <div className="menu_wrap">
            <RingTypeList {...this.props} />
            <div className="select_material">
              <h3 className="hidden_sp">素材を選択</h3>
              <ListMenu {...this.props} />
              {/*<ButtonEdit {...this.props} />*/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
